import script from "./JrPlyr.vue?vue&type=script&lang=js"
export * from "./JrPlyr.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__